<template>
	<dd class="pseudo-input mb-4" data-cy="tags">
		<input
			type="search"
			class="input-bare w-full flex-1"
			data-cy="input-tags"
			:placeholder="`${$t('tags')}:`"
			v-if="
				!tags || !tags.length
			"
			@click="openModal()"
		/>
		<span
			class="badge badge-secondary badge-sm mr-2 mb-2"
			v-for="(tag, index) in tags"
			v-bind:key="index"
		>
			{{ tag.name }}
			<a @click="removeTag(tag)"
				><b-icon icon="x"></b-icon
			></a>
		</span>
		<span
			class="badge badge-primary badge-sm mr-2 mb-2"
			v-if="tags && tags.length"
			@click="openModal()"
		>
			<b-icon icon="plus"></b-icon> {{ $t("add") }}
		</span>
	</dd>
</template>

<script>
export default {
	props: {
		tags: []
	},
	data() {
		return {
		};
	},
	methods: {
		openModal() {
			var self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t("select-tags"),
				selectCallback: function(selection) {
					const isSelected = self.tags.find((tag, i) => {
						if (tag.id === selection.id) {
							self.$delete(self.tags, i);
							return true;
						}
					});
					if (!isSelected) {
						self.tags.push(selection);
					}
				},
				selected: this.tags,
				data: this.$config.getValue("tags"),
				captionKey: "name"
			});
		},
		removeTag(selection) {
			const self = this;
			self.tags.find((tag, i) => {
				if (tag.id === selection.id) {
					self.$delete(self.tags, i);
					return true;
				}
			});
			return false;
		}
	},
	computed: {
	},
};
</script>
